import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeEstudioAmbiental } from "../../../../../../../redux/actions/resolucion";
import EstudiosAmbientalesSimpleTable from "./EstudiosAmbientalesSimpleTable";
import EstudiosAmbientalesFormContainer from "./form/EstudiosAmbientalesFormContainer";

const EstudiosAmbientalesTableContainer = () => {
    const dispatch = useDispatch();
    const [openEstudiosAmbientalesForm, setOpenEstudiosAmbientalesForm] = useState(false);
    const [estudioAmbiental, setEstudioAmbiental] = useState();
    const estudios = useSelector((state) => state.resolucion.abmSustancia.estudios);

    const handleOpenForm = (estudio) => {
        setEstudioAmbiental(estudio);
        setOpenEstudiosAmbientalesForm(true);
    }
    const handleDelete = (indices) => {
        dispatch(removeEstudioAmbiental(indices));
    }

    return (
        <>
            <EstudiosAmbientalesSimpleTable
                data={estudios}
                handleOpenForm={handleOpenForm}
                handleDelete={handleDelete}
            />
            <EstudiosAmbientalesFormContainer
                open={openEstudiosAmbientalesForm}
                formValues={estudioAmbiental}
                handleClose={() => setOpenEstudiosAmbientalesForm(false)}
            />
        </>
    )
}

export default EstudiosAmbientalesTableContainer;